import React, { useMemo } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import PostList from '../../organisms/PostList'
import Section from '../../sections/Section'
import { BlogCategorySliceProps } from './types'
import { PostListProps } from 'components/organisms/PostList/types'

const BlogCategorySlice: React.FC<BlogCategorySliceProps> = ({ slice }) => {
  const data = useStaticQuery<GatsbyTypes.WPPressReleasesCategoryQuery>(graphql`
    query WPPressReleasesCategory {
      wpEN {
        category(id: "press-releases", idType: SLUG) {
          slug
          name
          posts(last: 4) {
            nodes {
              excerpt
              categories(first: 1) {
                nodes {
                  name
                  slug
                }
              }
              date
              id
              slug
              title
              uri
              localizedWpmlUrl
              featuredImage {
                node {
                  sourceUrl
                  altText
                }
              }
            }
          }
        }
      }
    }
  `)

  if (!data) {
    return null
  }

  const { category } = data.wpEN || {}
  const posts = category?.posts?.nodes || []

  const postList = useMemo(() => {
    return posts.reduce((reduced: PostListProps['data'], post) => {
      if (!post) {
        return reduced
      }

      const { id, date, slug, localizedWpmlUrl, categories, title, featuredImage, excerpt } = post

      return [
        ...reduced,
        {
          id: id || '',
          date: date || '',
          slug: slug || '',
          url: localizedWpmlUrl,
          categories: {
            nodes: (categories?.nodes || []).map((category) => ({
              name: category?.name || '',
              slug: category?.slug || ''
            }))
          },
          title: title || '',
          featuredImage: {
            node: {
              sourceUrl: featuredImage?.node?.sourceUrl,
              altText: featuredImage?.node?.altText
            }
          },
          excerpt: excerpt || undefined
        }
      ]
    }, [])
  }, [posts])

  return (
    <Section
      heading={slice.primary?.bc_title?.text}
      isMainHeading={slice.primary?.bc_is_main_heading}
      isHeadingGreen
      inner="inners.primary"
      paddingTop={['80px', '', '120px']}
      paddingBottom={['20px', '', '120px']}
      headingPadding={['38px', '', '70px']}
      body={<PostList data={postList} cols={{ tablet: 4 }} />}
    />
  )
}

export default BlogCategorySlice
